import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  difficulty: {
    flexDirection: 'column',
    gap: 8,
    alignItems: 'baseline',
    marginVertical: 12,
  },
  label: { marginBottom: 8, fontFamily: 'InterSemiBold' },
});
